import { combineReducers } from "@reduxjs/toolkit";
import sessionPageReducers from './SessionPage';
import sessionResults from './SessionResults';
import accrualCalculator from './accrualCalculator';

export default combineReducers({
    sessionPage: sessionPageReducers,
    sessionResults,
    accrualCalculator
})